<template>
  <div class="userList">
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="add()">
        <i class="el-icon-plus" />新增
      </el-button>
    </div>
    <div class="tableBox">
      <el-table
        :data="tableData"
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{ textAlign: 'center' }"
        border
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="lunSort" label="排序" width="100"></el-table-column>
        <el-table-column prop="imgUrl" label="轮播图片">
          <template slot-scope="scope">
            <img :src="scope.row.imgUrl" alt="" style="width: 100px" />
          </template>
        </el-table-column>
        <el-table-column prop="imgUrl" label="详情图片">
          <template slot-scope="scope">
            <img :src="scope.row.detailsUrl" alt="" style="width: 100px" />
          </template>
        </el-table-column>
        <el-table-column prop="pages" label="跳转页面路径"></el-table-column>
        <el-table-column prop label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editData(scope.row)"
              >编辑</el-button
            >
            <el-button
              @click="deleteData(scope.row)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <UserDialog ref="dialog" @search="initPage" />
  </div>
</template>

<script>
import UserDialog from "./components/dialog.vue";
export default {
  components: { UserDialog },
  data() {
    return {
      page: {
        page: 1,
        size: 10,
      },
      params: {},
      total: 0,
      tableData: [],
    };
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.page.page - 1) * this.page.size;
    },
    handleSizeChange(size) {
      this.page.size = size;
      this.initPage();
    },
    handleCurrentChange(page) {
      this.page.page = page;
      this.initPage();
    },
    search(opt) {
      //搜索
      this.params = opt;
      this.initPage();
    },
    initPage() {
      this.getAjax("api/carousel/list", {}, "get").then((res) => {
        this.tableData = res.data;
      });
    },
    add() {
      this.$refs.dialog.visible = true;
      this.$refs.dialog.initDialog();
    },
    editData(item) {
      this.$refs.dialog.getInfo(item);
    },
    deleteData(item) {
      this.$confirm("确定删除吗？").then(() => {
        this.getAjax("api/carousel/del", { id: item.id }, "post").then(
          (res) => {
            this.$message.success("删除成功");
            this.initPage();
          }
        );
      });
    },
  },
  mounted() {
    this.initPage();
  },
};
</script>

<style lang="less">
.tianfulove {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  .leftBox {
    width: 220px;
    height: 100%;
    background: #545c64;
  }
  .rightBox {
    flex: 1;
    padding: 20px;
    .fenye {
      text-align: right;
      padding: 15px 10px;
    }
  }
}
</style>
